import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

const headingStyles: RichtextAdapterProps["customStyles"] = {
  heading: {
    mb: { base: 2, lg: 0 },
  },
  link: {
    fontSize: "lg",
    _visited: {},
  },
};

const itemTextStyles: RichtextAdapterProps["customStyles"] = {
  paragraph: { fontSize: "md" },
};

export { headingStyles, itemTextStyles };
